var map = {
	"./1.jpg": 7348,
	"./10.jpg": 1332,
	"./11.jpg": 5699,
	"./12.jpg": 4284,
	"./13.jpg": 6780,
	"./14.jpg": 1516,
	"./15.jpg": 8340,
	"./16.jpg": 9640,
	"./2.jpg": 1556,
	"./3.jpg": 999,
	"./4.jpg": 9040,
	"./5.jpg": 6632,
	"./6.jpg": 2856,
	"./7.jpg": 6851,
	"./8.jpg": 3332,
	"./9.jpg": 5868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9548;